import React from "react";
import {
  blockInvalidNumberKeys,
  parseNonNegativeDecimalInput,
  parseNonNegativeIntInput,
} from "../utils/nonNegativeNumberInput";

const CharacteristicField = ({
  label,
  formKey,
  placeholder,
  useRange,
  exact,
  min,
  max,
  allowDecimal = false,
  onExactChange,
  onMinChange,
  onMaxChange,
  onToggleRange,
}) => {
  const handleInput = (handler) => (e) => {
    const sanitized = allowDecimal
      ? parseNonNegativeDecimalInput(e.target.value)
      : parseNonNegativeIntInput(e.target.value);
    if (sanitized === null) return;
    handler(sanitized);
  };

  const handleKeyDown = (e) => blockInvalidNumberKeys(e, { allowDecimal });
  // text + inputMode decimal: acepta "." y "," sin que el browser los bloquee
  const inputType = allowDecimal ? "text" : "number";
  const inputMode = allowDecimal ? "decimal" : "numeric";

  const hasValue = useRange
    ? String(min).length > 0 || String(max).length > 0
    : String(exact).length > 0;

  return (
    <div
      className={[
        "characteristic-field",
        useRange ? "characteristic-field--range" : "",
        hasValue ? "characteristic-field--filled" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="characteristic-field__head">
        <label className="characteristic-field__label" htmlFor={`${formKey}-input`}>
          {label}
        </label>

        <div
          className="characteristic-field__mode"
          role="group"
          aria-label={`Modo de ${label}`}
        >
          <button
            type="button"
            className={`characteristic-field__mode-btn${
              !useRange ? " is-active" : ""
            }`}
            aria-pressed={!useRange}
            onClick={() => onToggleRange(formKey, false)}
          >
            Exacto
          </button>
          <button
            type="button"
            className={`characteristic-field__mode-btn${
              useRange ? " is-active" : ""
            }`}
            aria-pressed={useRange}
            onClick={() => onToggleRange(formKey, true)}
          >
            Rango
          </button>
        </div>
      </div>

      {!useRange ? (
        <div className="characteristic-field__control">
          <input
            id={`${formKey}-input`}
            type={inputType}
            min={allowDecimal ? undefined : 0}
            step={allowDecimal ? undefined : "1"}
            name={formKey}
            value={exact}
            onChange={handleInput(onExactChange)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            className="characteristic-field__input"
            inputMode={inputMode}
          />
        </div>
      ) : (
        <div className="characteristic-field__range">
          <div className="characteristic-field__control">
            <input
              id={`${formKey}-input`}
              type={inputType}
              min={allowDecimal ? undefined : 0}
              step={allowDecimal ? undefined : "1"}
              value={min}
              onChange={handleInput(onMinChange)}
              onKeyDown={handleKeyDown}
              placeholder="Desde"
              className="characteristic-field__input"
              aria-label={`${label} mínimo`}
              inputMode={inputMode}
            />
          </div>
          <span className="characteristic-field__separator" aria-hidden="true">
            –
          </span>
          <div className="characteristic-field__control">
            <input
              type={inputType}
              min={allowDecimal ? undefined : 0}
              step={allowDecimal ? undefined : "1"}
              value={max}
              onChange={handleInput(onMaxChange)}
              onKeyDown={handleKeyDown}
              placeholder="Hasta"
              className="characteristic-field__input"
              aria-label={`${label} máximo`}
              inputMode={inputMode}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CharacteristicField;
